module.exports = __webpack_public_path__ + "static/media/koa.c9266453.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/koa.png
// module id = 132
// module chunks = 0